import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./Reducers/authSlice";
import globalReducer from "./Reducers/globalSlice"
import botReducer from "./Reducers/botSlice"
import adminReducer from "./Reducers/adminActionSlice"

export const store = configureStore({
  reducer: {
    globalAuth: globalReducer,
    userAuth: userReducer,
    botAuth: botReducer,
    adminAuth: adminReducer
  },
});
